import axios from "axios";
import store from "../store";
import ls from "local-storage";

import {
    FETCH_ALL_WOO_LOCATION_PAGES,
    FETCH_SINGLE_WOO_LOCATION_PAGE,
    UPDATE_WOO_LOCATION_PAGE,
    CREATE_WOO_LOCATION_PAGE,
    DELETE_WOO_LOCATION_PAGE,
    ADD_LOCATION_IMAGE,
    PUBLISH_LOCATION_PAGE,
    GENERATE_LOCATION_PAGE_CONTENTS_OPENAI,
    interceptor
  } from ".";

interceptor(axios, store); 

export function fetchAllWooLocationPages() {
    return {
      type: FETCH_ALL_WOO_LOCATION_PAGES,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/locations`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

export function fetchSingleWooLocationPage(id) {
    return {
      type: FETCH_SINGLE_WOO_LOCATION_PAGE,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/locations/page/${id}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function updateWooLocationPage(id, data) {
    return {
      type: UPDATE_WOO_LOCATION_PAGE,
      payload: axios.put(
        `${process.env.REACT_APP_API_ENDPOINT}/core/locations/page/${id}`, 
        data,
        {
          headers: {
            Authorization: store.getState().cognito.token,
            PetShopId: store.getState().petShopReducer.currentPetshop.id,
          }
        }
      )
    };
  }

  export function createWooLocationPage(data) {
    return {
      type: CREATE_WOO_LOCATION_PAGE,
      payload: axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/core/locations/`,
        data,
        {
          headers: {
            Authorization: store.getState().cognito.token,
            PetShopId: store.getState().petShopReducer.currentPetshop.id,
          }
        }
      )
    };
  }

  export function deleteWooLocationPage(id) {
    return {
      type: DELETE_WOO_LOCATION_PAGE,
      payload: axios.delete(
        `${process.env.REACT_APP_API_ENDPOINT}/core/locations/${id}`,
        {},
        {
          headers: {
            Authorization: store.getState().cognito.token,
            PetShopId: store.getState().petShopReducer.currentPetshop.id,
          }
        }
      )
    };
  }

  export function uploadHeroImage(type,image) {
    const config = {
      headers: { 
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    };
  
    return {
      type: ADD_LOCATION_IMAGE,
      payload: axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/core/locations/uploadHeroImage/${type}`,
        image,
        config
      )
    };
  }

  export function statusChangeLocationPage(id,status) {  
    return {
      type: PUBLISH_LOCATION_PAGE,
      payload: axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/core/locations/page/changeStatus/${id}`,
        status,
        {
          headers: {
            Authorization: store.getState().cognito.token,
            PetShopId: store.getState().petShopReducer.currentPetshop.id,
          }
        }
      )
    };
  }

  export function generateLocationPageContentBaseOnOpenAi(data){
    return {
      type: GENERATE_LOCATION_PAGE_CONTENTS_OPENAI,
      payload: axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/core/locations/page/ai/generateContent`,
        data,
        {
          headers: {
            Authorization: store.getState().cognito.token,
            PetShopId: store.getState().petShopReducer.currentPetshop.id,
          }
        }
      )
    };
  }

  

  